import React from 'react';
import { useLocation } from 'react-router-dom';

const FloatingEmergencyExit = () => {
  const location = useLocation();
  
  // Don't show on login/signup pages
  const publicPages = ['/login', '/signup'];
  if (publicPages.includes(location.pathname)) {
    return null;
  }
  
  const triggerExit = () => {
    // Trigger the emergency exit by dispatching a custom event
    const emergencyEvent = new CustomEvent('trigger-emergency-exit');
    window.dispatchEvent(emergencyEvent);
  };

  return (
    <button
      onClick={triggerExit}
      className="fixed top-20 right-6 z-[9998] bg-red-500/80 hover:bg-red-600 backdrop-blur-sm text-white rounded-full p-3 shadow-lg hover:shadow-xl transition-all group"
      title="Quick Exit"
      aria-label="Emergency Exit"
    >
      {/* Exit icon */}
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
      </svg>
      
      {/* Tooltip */}
      <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-[#3E324D] text-white text-xs px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        Quick Exit
      </div>
    </button>
  );
};

export default FloatingEmergencyExit;
